import * as S from "./styles";

function Solicitando() {
  return (
    <S.CenterSheet>
      <S.DetailBox>
        <S.Destaque>
          Solicitando Corrida...
        </S.Destaque>
      </S.DetailBox>
    </S.CenterSheet>
  );
}
export default Solicitando;
